const closeButtonLabel = "Close";
const enGB = {
  closeButtonLabel
};
export {
  closeButtonLabel,
  enGB as default
};
